import IconWifi from "./icon-wifi";

export default IconWifi;